// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"brand-banners_bannerContainer__z1BVh","prev":"brand-banners_prev__e9OUe","next":"brand-banners_next__tUn78"};